import { getDeviceTotal } from '@/api/cloud';
import { getIccidByUid } from '@/api/subscriptions';
import { unfoldError } from '@/common/js/notice';
import { productsManager } from '@/lib';
import {  IPlan, ISubscription, ITotalDevice } from '@reolink-cloud/interface';

class DeviceManager {

    public deviceData: ITotalDevice[] = [];

    public async init( subscriptions: ISubscription[] = [], deviceStatuses: string[] = ['bound'] ): Promise<void> {

        try {

            const deviceData = await getDeviceTotal( deviceStatuses );
            const planIds = Array.from( new Set( deviceData.map( item => item.plan as string ).filter( id => id !== '' )));
            const plans = await Promise.all( planIds.map( id => productsManager.getPlanById( id )));
            this.deviceData = deviceData.map( item => {

                if ( item.plan === '' ) {

                    return item;

                }

                const subscription = subscriptions.find( sub => item.subscription === sub.id );
                const planTitle = plans.find( plan => plan.id === item.plan )?.series?.i18n.name;
                return { ...item, planTitle, subName: subscription?.title  };

            });

        } catch ( e ) {

            console.error( e );
            unfoldError( 'errors.server_error' );

        }

    }

    public getSubDeviceList( prevSub: ISubscription ): any[] {

        const deviceList: any[] = [];
        for ( const device of this.deviceData ) {

            if ( device.subscription === prevSub.id && ( device.status === 'associated' || device.unassociationReason === 'expired' )) {

                deviceList.push( device );

            }

        }

        return deviceList;

    }

    public getAvailableModelCount( availableModels: string[] ): number {

        let count = 0;
        for ( const device of this.deviceData ) {

            if ( availableModels.includes( device.model )) {

                count++;

            }

        }
        return count;

    }

    public checkIfDeviceAvailableInPlan( uid: string, plan: IPlan ): boolean {

        const deviceGroup = productsManager.getDeviceModelGroupByKey( plan.series?.deviceGroup ?? '' );
        const deviceInfo = this.deviceData.find( device => device.uid === uid );
        if ( deviceGroup && deviceInfo ) {

            return deviceGroup.modelsDetails.some( item => item.text === deviceInfo.model );

        }

        return false;

    }

    public getDeviceByUid( uid: string ): ITotalDevice | undefined {

        return this.deviceData.find( device => device.uid === uid );

    }

}

const deviceManager = new DeviceManager();
export { deviceManager };
